import { render, staticRenderFns } from "./BaseNumber.vue?vue&type=template&id=2ef641e1"
import script from "./BaseNumber.vue?vue&type=script&lang=js"
export * from "./BaseNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports